'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'AdminBadge';

var propTypes = {
  /** The badge's text */
  text: _propTypes2.default.node,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Inverts color */
  inverted: _propTypes2.default.bool,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  inverted: false,
  text: 'Admin'
};

/** Used for displaying a user's Admin role */
var AdminBadge = function AdminBadge(_ref) {
  var text = _ref.text,
      inverted = _ref.inverted,
      style = _ref.style,
      color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['text', 'inverted', 'style', 'color']);

  return _react2.default.createElement(
    'span',
    _extends({ style: _getStyles2.default.root(color, inverted, style) }, custom),
    text
  );
};

AdminBadge.displayName = displayName;
AdminBadge.propTypes = propTypes;
AdminBadge.defaultProps = defaultProps;

exports.default = AdminBadge;
module.exports = exports.default;